import { timeStampToString } from "../../../utils/commonServices";

export default (array)=> {
    const filterArray = (event) => {
        if (array?.data?.length > 0) {
          const temp = array?.data?.filter((searchedEvent) => {
            if (event.target.value == "") {
              return searchedEvent;
            } else if (
              searchedEvent?.name
                ?.toLowerCase()
                ?.includes(event.target.value.toLocaleLowerCase())
            ) {
              return searchedEvent;
            } else if (
              searchedEvent?.genre
                ?.toLowerCase()
                ?.includes(event.target.value.toLocaleLowerCase())
            ) {
              return searchedEvent;
            } else if (
              timeStampToString(searchedEvent?.start_date)
                ?.toLowerCase()
                ?.includes(event.target.value.toLocaleLowerCase())
            ) {
              return searchedEvent;
            } else if (
              timeStampToString(searchedEvent?.end_date)
                ?.toLowerCase()
                ?.includes(event.target.value.toLocaleLowerCase())
            )
              return searchedEvent;
          });
          return temp;
        }

       
      };
      return [filterArray]
}